// Apex landing footer colophon (DR-2026-314; DR-2026-248 slot-registry
// pattern, guides = reference). The DR-2026-314 Phase-3 fleet-logo row lands
// here (consent register in the DR governs which logos appear and where they
// link). Wording is operator-adjustable (voice-charter DEFINE layer).
import logoSrc from '../assets/ljusa-tider-logo.svg';

const HomeColophon = () => (
  <div className="home-colophon">
    <img src={logoSrc} alt="LJUSA TIDER" height="72" />
    <p>
      <strong>LJUSA TIDER</strong>
      <span className="colophon-meta">
        Built on Nick and Volto Light Theme — open source, end to end.
      </span>
    </p>
  </div>
);

export default HomeColophon;
